import React, { Fragment } from 'react';

import { FormattedMessage } from 'react-intl';

import {
  Checkbox,
  Col,
  FilterButton,
  Row,
  S,
  TableFilterCard,
} from '@modules/shared';

import styles from './GroupBy.less';

interface GroupBy {
  onChange: () => void;
  onSubmit: () => void;
  groupByStatus: boolean;
}

export const GroupBy: React.FC<GroupBy> = props => {
  const { onChange, onSubmit, groupByStatus } = props;

  return (
    <TableFilterCard
      className={styles.filter}
      content={
        <Fragment>
          <Row type="flex" justify="center" align="middle">
            <Col span={24} className={styles.filterCol}>
              <Checkbox
                name={'groupBy'}
                checked={groupByStatus}
                onChange={onChange()}
              >
                <S size="3" colored inline>
                  <FormattedMessage id="unitAdvancement.groupBy.subUnit" />
                </S>
              </Checkbox>
            </Col>
          </Row>
        </Fragment>
      }
      onSubmit={onSubmit}
    >
      <FilterButton className={styles.groupBy}>
        <FormattedMessage id="unitAdvancement.groupBy" />
      </FilterButton>
    </TableFilterCard>
  );
};
